import { useSnackbarContext } from "@repo/contexts/SnackbarContext";
import { useFormValidation } from "@repo/lib/hooks/common";
import { normalizeSaudiPhone, validation } from "@repo/lib/utils";
import { contactUs } from "@repo/server-actions/account";
import { useTranslations } from "next-intl";
import { useTransition } from "react";

// Separate initial form fields for each form type
const fullFormFields = {
  name: "",
  email: "",
  phoneNumber: "",
  message: "",
};

const homepageFormFields = {
  name: "",
  email: "",
  message: "",
};

const useContactUs = ({ isHomepage }) => {
  const { setSnackbar } = useSnackbarContext();
  const [isPending, startTransition] = useTransition();
  const tCommon = useTranslations("Common");
  // Use the appropriate initial form fields based on form type
  const initialFields = isHomepage ? homepageFormFields : fullFormFields;
  const {
    formValues,
    formErrors,
    setFormErrors,
    handleValidation,
    setFormValues,
  } = useFormValidation(initialFields);

  const sumbitForm = async () => {
    const payload = { ...formValues };
    // Normalize phone number by removing +966, 966, 00, or leading 0
    if (payload.phoneNumber) {
      payload.phoneNumber = normalizeSaudiPhone(payload.phoneNumber);
    }
    startTransition(async () => {
      const response = await contactUs(payload);
      setSnackbar({
        open: true,
        message: !response?.data
          ? tCommon("Something_Went_Wrong_Please_Try_Again")
          : tCommon("Enquiry_Submitted_Successfully"),
        type: !response?.data ? "error" : "success",
      });
      if (response?.data) {
        setFormValues(initialFields);
      }
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validation(formValues, tCommon);
    if (Object.keys(errors).length === 0) {
      sumbitForm();
    } else {
      setFormErrors(errors);
      console.log(
        "Failed to submit the form, please check the form fields",
        errors
      );
    }
  };

  return { handleSubmit, handleValidation, formValues, isPending, formErrors };
};

export default useContactUs;
